import React from 'react';
import { Navigate } from 'react-router-dom';
import { hasAnyRight } from '../utils/moduleRights.js';

export default function RequireRight({ anyOf = [], children }) {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem('user') || '{}');
  } catch {
    user = null;
  }
  if (!user?.userid) return <Navigate to="/" replace />;
  if (!hasAnyRight(user, anyOf)) return <Navigate to="/dashboard" replace />;
  return children;
}
